import * as algolia from '../services/algolia'

import { dispatchRequest } from '../helpers'
import createCastingService from '../services/createCasting'
import editCastingService, {
  addManualProfile as addManualProfileService,
  editCastingProfile as editCastingProfileService,
  editCastingProfiles as editCastingProfilesService,
} from '../services/editCasting'
import { LIST_TYPE } from '../constant'


export const editCasting = data => async (dispatch, getState) => {
  const { casting } = getState().castings
  const {
    profilesToAdd,
    profilesToRemove,
    ...rest
  } = data

  try {
    const nextCasting = {
      ...casting,
      ...rest,
    }

    dispatch({ type: 'EDIT_CASTING' })
    await editCastingService(casting.objectID, rest)
    const profiles = await editCastingProfilesService(casting.objectID, profilesToAdd, profilesToRemove)

    nextCasting.profiles = profiles.concat(nextCasting.profiles.filter(p => !profilesToRemove.includes(p.objectID)))

    return dispatch({
      data: nextCasting,
      type: 'EDIT_CASTING_SUCCESS',
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'EDIT_CASTING_ERROR',
    })
  }
}

export const editCastingProfile = (profileId, data) => async (dispatch, getState) => {
  const { casting } = getState().castings

  try {
    dispatch({ type: 'EDIT_CASTING_PROFILE' })
    const profile = await editCastingProfileService(casting.objectID, profileId, data)

    return dispatch({
      profile,
      type: 'EDIT_CASTING_PROFILE_SUCCESS',
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'EDIT_CASTING_PROFILE_ERROR',
    })
  }
}

export const addManualProfileToCasting = data => async (dispatch, getState) => {
  const { casting } = getState().castings

  try {
    dispatch({ type: 'EDIT_CASTING' })
    const profile = await addManualProfileService(casting.objectID, data)

    return dispatch({
      type: 'EDIT_CASTING_SUCCESS',
      data: {
        profiles: [profile].concat(casting.profiles),
      },
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'EDIT_CASTING_ERROR',
    })
  }
}

export const editCastingProfiles = (profilesToAdd, profilesToRemove) => async (dispatch, getState) => {
  const { casting } = getState().castings

  try {
    dispatch({ type: 'EDIT_CASTING' })
    const profiles = await editCastingProfilesService(casting.objectID, profilesToAdd, profilesToRemove)

    return dispatch({
      type: 'EDIT_CASTING_SUCCESS',
      data: {
        profiles: profiles.concat(casting.profiles.filter(p => !profilesToRemove.includes(p.profileId)))
      },
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'EDIT_CASTING_ERROR',
    })
  }
}

export const getCastings = (query, options = {}) => async (dispatch) => {
  return dispatchRequest(dispatch, 'GET_LIST', algolia.getAll(algolia.casting, query, options), {
    sort: options.sort || '',
    collection: LIST_TYPE.CASTING,
  })
}

export const getCasting = id => async (dispatch) => {
  dispatch({ type: 'GET_CASTING' })

  try {
    const data = await algolia.getCastingById(id)

    return dispatch({
      data,
      type: 'GET_CASTING_SUCCESS',
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_CASTING_ERROR',
    })
  }
}

export const createCasting = data => async (dispatch) => {
  try {
    dispatch({ type: 'CREATE_CASTING' })
    const result = await createCastingService(data)

    return dispatch({
      data: result,
      type: 'CREATE_CASTING_SUCCESS',
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'CREATE_CASTING_ERROR',
    })
  }
}
